import { z } from "zod";
const id = z.string().regex(/^[a-zA-Z0-9_-]{1,100}$/);
/** Place relationships use IDs. Text preserves narrative detail without acting as a selector. */
export const zWhereabouts = z
  .object({
    status: z.enum(["present", "travelling", "last-seen", "absent", "unknown"]),
    placeId: id.optional(),
    destinationId: id.optional(),
    text: z.string().max(600).optional(),
  })
  .strict();
export type Whereabouts = z.infer<typeof zWhereabouts>;
export const whereaboutsText = (value: Whereabouts | undefined) => value?.text || value?.placeId || value?.status || "";
export function remapWhereabouts(
  value: Whereabouts | undefined,
  mapping: Record<string, string>
): Whereabouts | undefined {
  return (
    value && {
      ...value,
      ...(value.placeId && mapping[value.placeId] ? { placeId: mapping[value.placeId] } : {}),
      ...(value.destinationId && mapping[value.destinationId] ? { destinationId: mapping[value.destinationId] } : {}),
    }
  );
}
